"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = ['small', 'medium'];

var CheckMarkIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CheckMarkIcon, _React$PureComponent);

  function CheckMarkIcon() {
    _classCallCheck(this, CheckMarkIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckMarkIcon).apply(this, arguments));
  }

  _createClass(CheckMarkIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          animatable = _this$props.animatable,
          checked = _this$props.checked,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className", "animatable", "checked"]);
      /* eslint-disable max-len */


      var svgs = {
        // specific case only meant for checkboxes
        small: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("polyline", {
            stroke: _ThemeManager.default.getVar(color) || color,
            points: "3.36,6.56 5.28,8.4 9.76,2.56"
          })
        },
        medium: {
          viewBox: '0 0 10 9',
          path: _react.default.createElement("path", {
            fill: _ThemeManager.default.getVar(color) || color,
            d: "M3.56016323,6.43525386 L8.21064778,0.456059439 C8.54971782,0.020112247 9.17799342,-0.0584222031 9.61394061,0.280647835 C10.0498878,0.619717873 10.1284223,1.24799347 9.78935222,1.68394067 L4.45601888,8.54108352 C4.09120331,9.01013212 3.40027672,9.0594562 2.9725311,8.64698721 L0.305864429,6.07555863 C-0.0916945972,5.69219814 -0.103204785,5.05913779 0.280155705,4.66157877 C0.663516195,4.26401974 1.29657654,4.25250955 1.69413557,4.63587004 L3.56016323,6.43525386 Z"
          })
        }
      };
      /* eslint-enable max-len */

      var svg = svgs[size];
      var styleProps = {
        'data-checked': checked
      };
      return _react.default.createElement(_IconWrapper.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), " check-mark-icon"), animatable ? 'animatable' : ''),
        viewBox: svg.viewBox,
        size: size
      }, styleProps, props), svg.path);
    }
  }]);

  return CheckMarkIcon;
}(_react.default.PureComponent);

exports.default = CheckMarkIcon;
CheckMarkIcon.defaultProps = {
  size: 'medium',
  color: 'inherit',
  animatable: false
};
CheckMarkIcon.propTypes = {
  size: _propTypes.default.oneOf(sizes),

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,
  color: _propTypes.default.string,

  /**
  * Is animatable
  */
  animatable: _propTypes.default.bool,

  /**
  * Toggle to show checked / uncheked state (w/ animatable)
  */
  checked: _propTypes.default.bool
};